import React from 'react';
import { motion } from 'framer-motion';
import { TreatedImage } from './TreatedImage';
import { ReserveButton } from './ReserveButton';
export function InvitationSection() {
  return <section className="relative py-24 md:py-32 bg-bc-surface overflow-hidden" data-id="element-103">
      <div className="container mx-auto px-6" data-id="element-104">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-105">
          {/* Imagery */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7,
          ease: [0.22, 1, 0.36, 1]
        }} className="relative order-2 lg:order-1" data-id="element-106">
            <TreatedImage src="https://cdn.magicpatterns.com/uploads/uyE2Th8nRwYis9q3qkoMAS/dr-fiona-frie.png" alt="Dr Fiona Frie, MD of Be CLINICAL" wrapperClassName="aspect-[2/3] w-full" className="object-top" data-id="element-107" />
            {/* Overlapping treatment detail */}
            <div className="absolute -bottom-8 -right-4 w-2/5 hidden sm:block" data-id="element-108">
              <TreatedImage src="https://cdn.magicpatterns.com/uploads/1PtEWfh9iWG4tZvgR5stro/2.png" alt="Collagen biostimulation in progress" wrapperClassName="aspect-square w-full bc-glow-box-soft" data-id="element-109" />
            </div>
          </motion.div>

          {/* Copy */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.7,
          delay: 0.1,
          ease: [0.22, 1, 0.36, 1]
        }} className="space-y-8 order-1 lg:order-2" data-id="element-110">
            {/* Eyebrow */}
            <div className="text-bc-pink font-sans text-sm md:text-base tracking-wide2 uppercase" data-id="element-111">
              YOU'RE INVITED
            </div>

            {/* Headline */}
            <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-bc-bone" data-id="element-112">
              AN EVENING WITH DR FIONA
            </h2>

            {/* Host subtext */}
            <p className="font-sans text-base md:text-lg text-bc-pink-soft tracking-label uppercase" data-id="element-113">
              Dr Fiona Frie, MD — your host for the evening
            </p>

            {/* Body paragraphs */}
            <div className="space-y-6 text-bc-bone-2 font-sans text-lg md:text-xl leading-relaxed md:leading-loose" data-id="element-114">
              <p data-id="element-115">
                We've been working on something we're truly excited about — and
                we'd love for you, as one of our valued patients, to be among
                the first to experience it. On Wednesday, June 24th, we're
                hosting an exclusive evening at Be CLINICAL to unveil our newest
                signature treatment: the Be CLINICAL Collagen Reset.
              </p>
              <p data-id="element-116">
                The Collagen Reset is a proprietary protocol developed
                exclusively by Be CLINICAL. Rather than relying on a single
                treatment, it combines five advanced regenerative technologies
                into one experience — working through heat, light,
                radiofrequency, biostimulation, and regenerative signaling to
                remodel collagen, improve skin quality, and address the visible
                signs of aging.
              </p>
            </div>

            <ReserveButton label="RESERVE YOUR SPOT" className="w-full sm:w-auto" data-id="element-117" />
          </motion.div>
        </div>
      </div>
    </section>;
}